import gql from "graphql-tag";
import { USER_FRAGMENT } from "./fragment";

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      ...UserInfo
    }
  }
  ${USER_FRAGMENT}
`;

export const CHECK_EMAIL_USER = gql`
  mutation CheckEmailUser($email: String!, $id: ID) {
    checkEmailUser(email: $email, id: $id)
  }
`;

export const SHARESHOLDERS_PERCENTS = gql`
  mutation SharesholdersPercents(
    $shares: [ShareholdersPercentInput]!
    $document: InputDocument
  ) {
    sharesholdersPercents(shares: $shares, document: $document)
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      ...UserInfo
    }
  }
  ${USER_FRAGMENT}
`;
